export default "__VITE_ASSET__DAB974tP__"